import { useState } from "react";
import { RiskAreaSaveModel } from "../riskAreaDialog/RiskAreaDialog.types";
import { RiskAreaRow, RiskAreaViewModel } from "./RiskAreas.types";
import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";
import { predefinedRiskAreasUrl } from "../predefinedRiskAreas/PredefinedRiskAreas.hooks";
import { useResponsibleQuery } from "../../../user/hooks/useResponsibleQuery";
import { useTranslation } from "@localization/useTranslation";

// The assessment count is list-only context, not part of what gets saved back, so it is dropped here rather
// than riding along in every update request.
export function toSaveModel(riskArea: RiskAreaViewModel): RiskAreaSaveModel {
    const { assessmentCount, ...saveModel } = riskArea;
    return saveModel;
}

export function useRiskAreasDataMapping() {
    const { translateRiskAreaAssessmentLevel } = useTranslation();
    const queryClient = useDotLegalQueryClient();
    const [showTemplateDialog, setShowTemplateDialog] = useState(false);
    const [showRiskAreaDialog, setShowRiskAreaDialog] = useState(false);
    const [riskAreaForDeletion, setRiskAreaForDeletion] = useState<RiskAreaViewModel | undefined>(undefined);
    const [selectedRiskArea, setSelectedRiskArea] = useState<RiskAreaSaveModel | undefined>(undefined);

    const url = "/risk-areas";
    const { isLoading, data } = useDotLegalQuery<Array<RiskAreaViewModel>>(url);

    const responsibleQuery = useResponsibleQuery();

    const rows: Array<RiskAreaRow> | undefined = data?.map((riskArea) => ({
        ...riskArea,
        responsibleName: responsibleQuery.userData?.find((user) => user.id === riskArea.responsibleId)?.name ?? "",
        assessmentLevelName: translateRiskAreaAssessmentLevel(riskArea.assessmentLevel),
    }));

    const hasRiskAreas = isLoading || (rows?.length ?? 0) > 0;

    const onSave = () => {
        queryClient.refetchQueries(url);
        queryClient.refetchQueries("riskAreasMenu");
        queryClient.refetchQueries(predefinedRiskAreasUrl);
    };

    return {
        isLoading,
        data: rows,
        hasRiskAreas,
        showTemplateDialog,
        setShowTemplateDialog,
        showRiskAreaDialog,
        setShowRiskAreaDialog,
        riskAreaForDeletion,
        setRiskAreaForDeletion,
        onSave,
        selectedRiskArea,
        setSelectedRiskArea,
    };
}
